import { SearchTextFilter } from "@me8eon/searchtext_filters";
import { MimeTypeFilters } from "@me8eon/mimetype_filter";
import { JwtTokenFn } from "@me8eon/authentication";
import { DepartmentTypeFilters } from "@me8eon/departmenttype_filter";
export const graphSearchAggregates = "graphSearchAggregates";
import { graphApiPeopleDs } from "./graph.api.people.data.source";
export interface GraphApiHit {
    name: string;
    webUrl: string;
    createdDateTime: string;
    lastModifiedDateTime: string;
    size: number;
    file?: any; // Add proper typing if possible
    parentReference?: any; // Add proper typing if possible
    hitHighlightedSummary?: string;
}

export interface GraphApiHitsContainer {
    hits: GraphApiHit[];
    total: number;
    moreResultsAvailable: boolean;
    aggregates?: {
        departmentType?: string[];
    };
}

export interface GraphApiResponse {
    searchTerms: string[];
    hitsContainers: GraphApiHitsContainer[];
}

export type GraphApiEntityType = "people" | "driveItem" | "message" | "chatMessage";

export type GraphApiFilters = SearchTextFilter & MimeTypeFilters & DepartmentTypeFilters

export type GraphApiQuery = {
    requests: {
        entityTypes: GraphApiEntityType[];
        query: {
            queryString: string;
        };
        from?: number
        size?: number;
        selectProperties: string[];
    }[];

}


export function filtersToQueryString(filters: GraphApiFilters) {
    const search = filters.searchText;
    return search;
}

export type MakeGraphApiRequest = (url: string, token: JwtTokenFn, body: object) => Promise<GraphApiResponse[]>;

export async function _makeGraphApiRequest(url: string, tokenFn: JwtTokenFn, body: object): Promise<GraphApiResponse[]> {
    const token = await tokenFn();
    if (!token) {
        console.error("No token provided for Graph API request", url, body);
        return [];
    }
    const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
    };

    const response = await fetch(url, {
        method: "POST",
        headers,
        body: JSON.stringify(body),
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Graph API request failed: ${response.status} - ${errorText}`);
    }

    const result = await response.json();
    if (!result.value || !Array.isArray(result.value)) {
        throw new Error(
            `Unexpected Graph API response format: ${response.status} - ${JSON.stringify(result, null, 2)}`,
        );
    }
    return result.value;
}

export type GraphApiContext = {
    graphApiUrl: string;
    token: JwtTokenFn;
    MakeGraphApiRequest?: MakeGraphApiRequest;
    isAggrFilter?: boolean;
};

export type GraphApiPaging = {}

